import z from 'zod';

export const SalesOrderSplitResultSchema = z.object({
    id: z.number(),
    manufacturerReference: z.string(),
});

export type SalesOrderSplitResult = z.infer<typeof SalesOrderSplitResultSchema>;
